import React from "react";
import "../App.css";
const NotFound = () => {
  return (
    <div className="no-found">
      <h1 style={{ textAlign: "center", fontSize: "15em", fontWeight: 800 }}>
        404
      </h1>
      <p style={{ fontSize: "2em", textAlign: "center" }}>
        Oops! Something is wrong.
      </p>
    </div>
  );
};

export default NotFound;
